import { Box, Tooltip } from "@chakra-ui/react";
import { ChakraProps } from "@chakra-ui/system";
import { useFormState } from "react-hook-form";
import { usePrefixedFieldName } from "shared/components/form/FormFieldPrefix";
import { getFieldError } from "shared/utils/FormUtils";

export interface ErrorTooltipProps {
  error?: string;
  wrapperProps?: ChakraProps;
}

export const ErrorTooltip: React.FC<
  React.PropsWithChildren<ErrorTooltipProps>
> = ({ error, wrapperProps, children }) => (
  <Tooltip bg="red.600" color="white" isDisabled={!error} label={error}>
    <Box className="mb-error-tooltip-wrapper" {...wrapperProps}>
      {children}
    </Box>
  </Tooltip>
);

export interface FormErrorTooltipProps extends ErrorTooltipProps {
  name: string;
}

export const FormErrorTooltip: React.FC<
  React.PropsWithChildren<FormErrorTooltipProps>
> = ({ name, children, ...props }) => {
  const prefixedName = usePrefixedFieldName(name);
  const { errors } = useFormState();
  const error = getFieldError(errors, prefixedName)?.message;
  return (
    <ErrorTooltip error={error} {...props}>
      {children}
    </ErrorTooltip>
  );
};
